"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var appendPathIndex_1 = __importDefault(require("./appendPathIndex"));
var appendPath_1 = __importDefault(require("./appendPath"));
var getValue_1 = __importDefault(require("./getValue"));
var cache = __importStar(require("./cache"));
var BRACKETS = /[[\]]+/;
/**
 * This function retrieves the value from an array based on the provided indicies.
 * @param {unknown} value The value to evaluate
 * @param {string} indicies The indicies to evaluate in the form of '[0][1][2]...[n]'
 * @param {string} currentPath The current path
 * @param {string} path The full path
 * @returns {unknown} The value retrieved from the array based on the indicies.
 */
var getValueFromIndicies = function (value, indicies, currentPath, path) {
    var finalPath = (0, appendPath_1.default)(currentPath, indicies);
    // Check if the current path is in the cache
    if (cache.has(finalPath))
        return cache.get(finalPath);
    // Split the indicie values into an array of keys
    var keys = indicies.split(BRACKETS).filter(Boolean);
    for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
        var key = keys_1[_i];
        // Append the [key] to the current path
        currentPath = (0, appendPathIndex_1.default)(currentPath, key);
        // Retrieve the value associated with the key
        value = (0, getValue_1.default)(value, key, currentPath, path);
        // quit if the value is undefined
        if (value === undefined)
            break;
    }
    return value;
};
exports.default = getValueFromIndicies;
